angular.module('impactx.autocompletegroup').directive('ixAutocompleteSelectable', function () {
    return {
        restrict: 'A',
        link: function(scope, element) {
            var upperLiElement = element.closest('li');
            upperLiElement.addClass('autocomplete-non-selectable');
        }
    };
});